import { getAgencyLocalTravelStatus } from 'Application/utils';
import { FC, lazy } from 'react';
import { Navigate } from 'react-router';
import Loadable from 'ui-component/Loadable';

const AgencyPage = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/Agency/Shared/AgencyPage')));

export const ProtectedAgencyLocalTravelRoute: FC = () => {
    const agencyLocalTravelStatus = getAgencyLocalTravelStatus();

    if (!agencyLocalTravelStatus) {
        return <Navigate to="*" state={{ from: window.location.pathname }} replace />;
    }

    return <AgencyPage />;
};
